import { render } from "./BlogPost.vue?vue&type=template&id=1720910e&scoped=true"
import script from "../js/blog-post.js?vue&type=script&lang=js"
export * from "../js/blog-post.js?vue&type=script&lang=js"

import "./BlogPost.vue?vue&type=style&index=0&id=1720910e&scoped=true&lang=css"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/platinumlandscapemi/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1720910e"]])

export default __exports__